import { render } from "./Item.vue?vue&type=template&id=057093f7&scoped=true&ts=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=057093f7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057093f7"]])

export default __exports__